import lazyStore from "../store/lazyStore";
import { LoadingActions } from "../store/reducers/loading";
import { smart_captcha } from "./smart-captcha";

export type SmartCaptchaParams = {
  captcha?: 'smart-captcha' | 'recaptcha';
  token3?: string;
  token2?: string;
  sign?: any;
  nonce?: any;
  date?: any;
}

export const createSmartCaptchaRunner = <T = any>(
  callback: (params: SmartCaptchaParams) => Promise<T>,
  options?: {
    action?: string;
    getRecaptchaParams?: (response: T) => (Pick<SmartCaptchaParams, 'sign' | 'nonce' | 'date'> | null | undefined);
  }
) => {
  const action = options?.action
  const getRecaptchaParams = options?.getRecaptchaParams ?? ((res: any) => ({
    sign: res?.data?.message?.sign ?? res?.data?.sign,
    nonce: res?.data?.message?.nonce ?? res?.data?.nonce,
    date: res?.data?.message?.date ?? res?.data?.date,
  }));
  const runner = async () => {
    await smart_captcha.ready()
    const { token3 } = await smart_captcha.execute(action ? { action } : undefined)
    const response = await callback({ token3, captcha: 'smart-captcha' })
    const recaptchaParams = getRecaptchaParams(response)
    if (recaptchaParams?.sign && recaptchaParams?.nonce) {
      const { sign, nonce, date } = recaptchaParams
      lazyStore.store.dispatch(LoadingActions.hide())
      const { token2 } = await smart_captcha.render()
      lazyStore.store.dispatch(LoadingActions.clear())
      return callback({ token3, token2, sign, nonce, date, captcha: 'smart-captcha' })
    }
    return response
  }
  return runner;
}